import service from '@/services/product/ProductService'

function verifyCartName(prop) {
  let viewContext =
    localStorage.getItem('viewContext') ||
    process.env.VUE_APP_INIT_VIEWCONTEXT ||
    'companyList'

  let idCompany =
    viewContext == 'companyList' ? localStorage.getItem('idCompanyList') : null

  let cartName = `${prop}.${viewContext}`

  return idCompany ? `${cartName}.${idCompany}` : cartName
}

function getListFromStorage(propName) {
  return localStorage.getItem(propName)
    ? JSON.parse(localStorage.getItem(propName))
    : []
}

let localCart = getListFromStorage(verifyCartName('cart'))
let localWishList = getListFromStorage(verifyCartName('wish'))

export const productModule = {
  strict: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state: {
    product: null,
    productList: [],
    filteredProductList: [],
    loadingItems: false,
    pagination: {
      page: 1,
      current_page: 1,
      last_page: 1,
      per_page: 30,
      to: 0,
      total: 0,
    },
    header: [],
    filterPrice: [],
    filter: {
      price: '',
      marca: '',
      searchText: '',
    },
    cart: localCart,
    wishList: localWishList,
    cartProducts: [],
    subCategories: [],
  },
  mutations: {
    SET_PAGINATION(state, payload) {
      state.pagination.current_page = payload.current_page
      state.pagination.last_page = payload.last_page
      state.pagination.per_page = parseInt(payload.per_page)
      state.pagination.total = parseInt(payload.total)
    },
    SET_SUBCATEGORIES_LIST(state, payload) {
      state.subCategories = payload ?? []
    },
    SET_PRICES_LIST(state, payload) {
      if (!payload) return []
      const prices = payload.map((ele) => {
        return {
          ...ele,
          DESCRICAO: ele.DESCRICAO.slice(2).trim() + '(' + ele.QTDITENS + ')',
          VALOR: ele.VALOR.trim(),
        }
      })

      const qtdTotal = prices.reduce((val, p) => {
        return (val += p.QTDITENS)
      }, 0)

      state.filterPrice = [
        { DESCRICAO: 'Todos', QTDITENS: qtdTotal, VALOR: 0 },
      ].concat(prices)
    },
    SET_PRODUCT_LIST(state, payload) {
      const items = payload
        ? payload.map((product) => {
            if (product.itens) {
              product = {
                ...product.itens,
                ...product,
              }
              delete product.itens
            }

            let photoList = []
            if (product.itens_complemento) {
              let obj = product.itens_complemento
              Object.keys(obj).forEach((field) => {
                if (field.startsWith('IMAGEM') && obj[field])
                  photoList.push('data:image/jpeg;base64,' + obj[field])
              })
            }

            const currencies = this.getters['systemModule/getSystemCurrencies']
            const currencySystem = this.state.systemModule.moeda
            const currentCurrency = currencies.find(
              (c) => c.index == currencySystem
            )

            let obj = {
              id: product.CODIGO,
              name:
                product.DESCRICAOINTERNET &&
                product.DESCRICAOINTERNET.length > 0
                  ? product.DESCRICAOINTERNET
                  : product.DESCRICAO,

              category: product ? product.MARCA : null,
              subCategory: product ? product.GRUPO : null,
              defaultPrice: parseFloat(product.PRECOVAREJO ?? 0).toFixed(2),
              price: product.PRECOITEM
                ? parseFloat(product.PRECOITEM[currentCurrency.cifrao]).toFixed(
                    2
                  )
                : parseFloat(product.PRECOVAREJO ?? 0).toFixed(2),
              offerPrice: product.OFERTAVAREJO
                ? parseFloat(
                    product.OFERTAVAREJO[currentCurrency.cifrao] ??
                      product.OFERTAVAREJO ??
                      0
                  ).toFixed(2)
                : '0.00',

              isOffer:
                product.OFERTAVAREJO &&
                parseFloat(
                  product.OFERTAVAREJO[currentCurrency.cifrao] ??
                    product.OFERTAVAREJO
                ) > 0,
              specifications: product.itens_complemento
                ? product.itens_complemento.ESPECIFICACOES
                : 'Não existem especificações para este produto',
              specificationsHtml: product.itens_complemento
                ? product.itens_complemento.ESPECIFICACOESHTML
                : null,
              image: photoList.length > 0 ? photoList[0] : null,
              photoList: photoList,
              stock: parseInt(product.SALDOITEM),
            }

            // PROPERTIES FROM COMPANYLIST
            obj.quantity = product.QUANTIDADE ? parseInt(product.QUANTIDADE) : 0
            obj.processed = product.QUANTIDADEPROC
              ? parseInt(product.QUANTIDADEPROC)
              : 0
            obj.avaiable = obj.quantity - obj.processed

            return obj
          })
        : []

      state.productList = items.filter((i) => i.stock > 0)
    },
    SET_PRODUCT(state, payload) {
      state.product = payload.data
    },
    SET_LOADING(state) {
      state.loadingItems = !state.loadingItems
    },

    ADD_ITEM_TO_CART(state, payload) {
      const { id, quantity } = payload
      let product = state.productList.filter((v) => v.id == id)[0]

      if (!product) product = state.cartProducts.filter((v) => v.id == id)[0]

      if (payload.stock >= quantity) {
        const idx = state.cart.findIndex((product) => {
          return product.id === id
        })

        if (idx === -1) {
          state.cart.push({
            ...payload,
          })
        } else if (payload.stock >= state.cart[idx].quantity + quantity) {
          state.cart[idx].quantity += quantity
          state.cart[idx].stock = payload.stock
        } else {
          state.cart[idx].stock = payload.stock
          state.cart[idx].quantity = parseInt(payload.stock)
          localStorage.setItem(
            verifyCartName('cart'),
            JSON.stringify(state.cart)
          )
          throw 'Atingiu a quantidade máxima disponível em estoque'
        }

        localStorage.setItem(verifyCartName('cart'), JSON.stringify(state.cart))
      } else {
        throw 'Não possui estoque'
      }
    },

    ADD_ITEM_TO_WISHLIST(state, payload) {
      const { id } = payload

      const idx = state.wishList.findIndex((wish) => {
        return wish.id === id
      })

      if (idx === -1) {
        state.wishList.push({
          ...payload,
        })
      }

      localStorage.setItem(
        verifyCartName('wish'),
        JSON.stringify(state.wishList)
      )
    },

    REMOVE_ITEM_FROM_WISHLIST(state, payload) {
      const { id } = payload
      state.wishList = state.wishList.filter((product) => {
        return product.id !== id
      })
      localStorage.setItem(
        verifyCartName('wish'),
        JSON.stringify(state.wishList)
      )
    },

    REMOVE_ITEM_FROM_CART(state, payload) {
      const { id } = payload
      const idx = state.cart.findIndex((product) => {
        return product.id === id
      })

      if (state.cart[idx].quantity - 1 > 0) state.cart[idx].quantity -= 1
      else state.cart = state.cart.filter((item) => item.id !== id)

      localStorage.setItem(verifyCartName('cart'), JSON.stringify(state.cart))
    },
    UPDATE_FILTER(state, payload) {
      
      if (!payload) return
      
      const price =
        payload.price && payload.price.VALOR
          ? payload.price.VALOR
          : payload.price

      state.filter = {
        price: price,
        searchText:
          payload.searchText || payload.searchText == ''
            ? payload.searchText
            : state.filter.searchText,
        marca: payload.marca ?? state.filter.marca,
      }

      // let list = Object.assign([], state.productList)
      // if (list && list.length <= 0) return []
      // state.filteredProductList = list
    },

    CLEAR_CART(state) {
      localStorage.removeItem(verifyCartName('cart'))
      state.cart = []
    },

    /** RECUPERAR AMBAS LISTAS CARRINHO E FAVORITOS */
    RETRIEVE_LOCALSTORAGE_CART(state) {
      state.cart = getListFromStorage(verifyCartName('cart'))
      state.wishList = getListFromStorage(verifyCartName('wish'))
    },

    UPDATE_PRODUCTS_CART(state, payload) {
      state.cartProducts = payload
    },
    CLEAR_PRODUCTS_CART(state) {
      state.cartProducts = []
    },

    CLEAR_WISHLIST(state) {
      localStorage.removeItem(verifyCartName('wish'))
      state.wishList = []
    },
  },
  actions: {
    async addItemToCart({ state, dispatch, commit }, payload) {
      const item = await dispatch('getItems', [{ id: payload.id }])
      await commit('ADD_ITEM_TO_CART', {
        ...item[0],
        quantity: payload.quantity,
      })
    },

    removeItemFromCart({ commit }, payload) {
      commit('REMOVE_ITEM_FROM_CART', payload)
    },

    updateFilter({ commit }, payload) {
      commit('UPDATE_FILTER', payload)
    },
    clearCart({ commit }) {
      commit('CLEAR_CART')
      commit('CLEAR_PRODUCTS_CART')
    },
    clearWishList({ commit }) {
      commit('CLEAR_WISHLIST')
    },
    async retrieveCart({ state, commit, dispatch }) {
      commit('RETRIEVE_LOCALSTORAGE_CART')
      if (state.cart && state.cart.length > 0) await dispatch('updateCartItems')
    },
    async getItems({ commit }, payload) {
      const { data } = await service.getItems(payload)
      return data
    },
    async updateCartItems({ commit, state }) {
      const { data } = await service.getItems(state.cart)
      commit('UPDATE_PRODUCTS_CART', data)
    },

    /**
     * LISTA DE DESEJOS
     */

    addItemToWishList({ commit }, payload) {
      commit('ADD_ITEM_TO_WISHLIST', payload)
    },

    removeItemFromWishList({ commit }, payload) {
      commit('REMOVE_ITEM_FROM_WISHLIST', payload)
    },

    /**
     *  Get Product List by filter from backend
     */
    async getProducts({ state, commit }, payload) {
      try {
        commit('SET_LOADING')
        if (!payload) payload = {}
        if (!payload.page) payload.page = 1
        if (!payload.per_page) payload.per_page = state.pagination.per_page
        if (state.filter.marca) payload.marca = state.filter.marca
        if (state.filter.price) payload.price = state.filter.price
        if (state.filter.searchText) payload.HIBRIDO = state.filter.searchText
        payload.MOEDA = process.env.VUE_APP_MOEDAPRINCIPAL
        
        const response = await service.getProducts(payload)

        commit('SET_PRODUCT_LIST', response.data)
        commit('SET_SUBCATEGORIES_LIST', response.marcas)
        commit('SET_PRICES_LIST', response.precos)
        commit('UPDATE_FILTER')
        commit('SET_PAGINATION', response)
      } finally {
        commit('SET_LOADING')
      }
    },

    async getProduct({ commit }, payload) {
      const response = await service.getProduct(payload)
      commit('SET_PRODUCT', response)
    },

    /**
     *  Expect a List of Products from others contexts to set
     */
    async setProductList({ commit }, payload) {
      commit('SET_PRODUCT_LIST', payload)
    },
  },
  getters: {
    filteredProductList: (state) => {
      return state.filteredProductList
    },

    products: (state) => {
      return state.productList
    },

    subCategories: (state) => {
      const qtdTotal = state.subCategories.reduce((val, sub) => {
        return (val += sub.QTDITENS)
      }, 0)
      return [{ MARCA: 'Todos', QTDITENS: qtdTotal }].concat(
        state.subCategories.sort()
      )
    },

    wishList: (state) => {
      return state.wishList
    },

    cart: (state) => {
      return state.cart
    },

    cartDetail: (state) => {
      let cart = []

      if (state.cart && state.cart.length > 0) {
        cart = state.cart.map((item) => {
          const product = state.cartProducts.filter(
            (product) => item.id === product.id
          )[0]

          if (!product) return {}

          return {
            ...item,
            price: product.price,
            image: product.image
              ? 'data:image/jpeg;base64,' + product.image
              : '',
            name: product.name,
            stock: product.stock,
            avaiable: product.avaiable,
            processed: product.processed,
          }
        })
      }
      return cart ?? []
    },

    soldOutItems: (state, getters) => {
      const items = getters.cartDetail
        ? getters.cartDetail.filter(
            (product) => product.stock <= 0 || product.quantity > product.stock
          )
        : []
      return items
    },

    percentOfferProduct() {
      return (product) => {
        return (
          (parseFloat(product.offerPrice) / parseFloat(product.price) - 1) *
          100 *
          -1
        ).toFixed(0)
      }
    },

    soldOutProduct() {
      return (product) => {
        return (
          (product && product.stock <= 0) || product.quantity > product.stock
        )
      }
    },
  },
}
